<div [ngClass]="{'avatar':!imageUrl}" [ngStyle]="{'width':avatarSize,'height':avatarSize}">
    <ng-container *ngIf="imageUrl; else initialsTemplate">
        <img [src]="imageUrl" [alt]="name" [ngStyle]="{'width': '100%', 'height': '100%'}" />
    </ng-container>
    <ng-template #initialsTemplate>
        <span class="initials">{{ initials }}</span>
    </ng-template>
</div>